<template>
  <div style="height: 100%;">
    <Header :headMenu="[]" :showSwitch="false">
      <div slot="right" class="align-center">
        <user-popover :showCompanyName="false"></user-popover>
      </div>
    </Header>
    <div class="main-container">
      <div style="padding-top: 94px;">
        <div class="container-inner">
          <div class="img-container">
            <img src="../assets/images/chooseorg_img.png" style="width: 406px;" />
          </div>
          <div class="right-container">
            <div class="tip" v-if="!currentOrg">当前账号暂无企业</div>
            <div v-else-if="isAuthenticationApplied" class="tip">企业正在认证中</div>
            <div v-else-if="currentOrg.memberType!==0&&currentOrg.isAuthentication!==1" class="tip">当前企业未认证，暂时无法进入</div>
            <div v-else-if="currentOrg.isAuthentication!==1" class="tip">当前企业未认证，暂时无法进入，请联系企业管理员进行认证</div>
            <div v-else-if="currentOrg.memberType===0" class="tip">当前账号无物联平台使用权限，请联系企业管理员</div>
            <div v-else class="tip"></div>
            <div class="align-center" v-if="orgList.length">
              <i class="el-icon-arrow-left" v-if="orgList.length>1" @click="prev"></i>
                <transition-group name="switch-list" class="switch-row">
                  <span v-for="(company, index) in orgList" :key="company.id" :class="['logo-container', {center:centerIndex===index}, {hide:index>=3}]"
                    :style="`left:${(1+index-centerIndex)*80}px;`">
                    <div class="logo">
                      <img :src="company.logo + '?x-oss-process=image/resize,w_50,limit_0'" v-if="!company.error" @error="imgError(company)">
                      <img v-if="company.error" src="../assets/images/org_default_logo.png">
                      <i class="not-auth-tag" v-if="company.isAuthentication !== 1"></i>
                    </div>
                  </span>
                </transition-group>
              <i class="el-icon-arrow-right" v-if="orgList.length>1" @click="next"></i>
            </div>
            <div style="height: 150px;">
              <div class="company-name" v-if="currentOrg">{{currentOrg.orgName}}</div>
              <div class="company-name" v-else></div>
              <template v-if="!currentOrg">
                <el-button type="primary" @click="toCreate">创建企业</el-button>
                <el-button type="primary" @click="toJoin">加入企业</el-button>
              </template>
              <el-button type="primary" v-else-if="currentOrg.memberType!==0&&currentOrg.isAuthentication!==1&&!isAuthenticationApplied" @click="toRecognize">立即认证</el-button>
              <el-button v-else-if="currentOrg.memberType!==0&&currentOrg.isAuthentication===1" type="primary" @click="toHome">立即进入</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import userPopover from '@/components/userPopover'
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      orgList: [],
      currentIndex: 0,
      switchClass: '',
      centerIndex: 1,
      isAuthenticationApplied: false
    }
  },
  components: {
    Header,
    userPopover
  },
  async mounted () {
    const res = await this.GetMyOrganizations()
    if (res.code === 1000) {
      this.orgList = res.data
      if (this.orgList.length >= 3) {
        this.centerIndex = 1
        if (this.userInfo.orgId) {
          const index = this.orgList.findIndex(({ id }) => id === this.userInfo.orgId)
          if (index === 0) {
            this.orgList.unshift(this.orgList.pop())
          } else if (index > 1) {
            const list = this.orgList.splice(0, index - 1)
            this.orgList = this.orgList.concat(list)
          }
        }
      } else {
        this.centerIndex = 0
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    currentOrg () {
      if(!this.orgList.length) {
        return null
      }
      if (this.orgList.length <= 2) {
        return this.orgList[0]
      }
      return this.orgList[1]
    }
  },
  watch: {
    async currentOrg (val) {
      this.isAuthenticationApplied = false
      if (val && val.id && val.memberType !== 0 && val.isAuthentication !== 1) {
        const res = await this.GetAuthInfo({
          orgId: val.id
        })
        if (res.code === 1000 && res.data.orgId && res.data.approvalState === 0) {
          this.isAuthenticationApplied = true
        }
      }
    },
    'userInfo.orgId' (val) {
      if (val) {
        const index = this.orgList.findIndex(({ id }) => id === val)
        if (index === 0) {
          this.orgList.unshift(this.orgList.pop())
        } else if (index > 1) {
          const list = this.orgList.splice(0, index - 1)
          this.orgList = this.orgList.concat(list)
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['GetMyOrganizations', 'ChangeMember', 'GetAuthInfo']),
    next () {
      this.orgList.push(this.orgList.shift())
    },
    prev () {
      this.orgList.unshift(this.orgList.pop())
    },
    imgError (company) {
      this.$set(company, 'error', true)
    },
    async setMain (cb) {
      if (this.currentOrg.id !== this.userInfo.orgId) {
        const loading = this.$loading({
          fullscreen: true,
          background: 'transparent'
        })
        const res = await this.ChangeMember({
          orgId: this.currentOrg.id,
          memberId: this.currentOrg.memberId
        })
        if (res.code === 1000) {
          cb()
        } else if (res.code === 5000) {
          this.$message.error('组织不存在')
        } else if (res.code === 5003) {
          this.$message.error('企业成员不存在')
        }
        loading.close()
      } else {
        cb()
      }
    },
    async toHome () {
      this.setMain(() => {
        this.$router.push('/main/production')
      })
    },
    toRecognize () {
      this.setMain(() => {
        window.location.href = process.env.VUE_APP_SITE_HOST + `/pc/platform/index.html#/recognize?orgId=${this.userInfo.orgId}&platformSource=iotplatform`
      })
    },
    toCreate () {
      window.location.href = process.env.VUE_APP_SITE_HOST + `/pc/platform/index.html#/createOrg?platformSource=iotplatform`
    },
    toJoin () {
      window.location.href = process.env.VUE_APP_SITE_HOST + `/pc/platform/index.html#/applyIntoCompany?platformSource=iotplatform`
    }
  }
}
</script>

<style lang="less" scoped>
.logo-container{
  position: absolute;
  width: 80px;
  height: 80px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  z-index: 3;
  &:first-child,&:last-child{
    z-index: 1;
  }
  .logo{
    width: 100%;
    height: 100%;
    transform: scale(0.625);
    transition: transform 1s;
    img{
      border-radius: 8px;
      width: 100%;
      height: 100%;
    }
  }
  &.center{
    z-index: 99;
    .logo{
      transform: scale(0.9);
    }
  }
  &.hide{
    .logo{
      transform: scale(0);
    }
  }
  .not-auth-tag{
    position: absolute;
    right: 0;
    top: 0;
    width: 36px;
    height: 36px;
    background: url("~@/assets/images/icon_notauth.png") center no-repeat;
    background-size: 100%;
  }
}

.switch-list-move{
  transition: all 1s;
}
.switch-row{
  display: flex;
  align-items: center;
  position: relative;
  width: 240px;
  overflow: hidden;
  height: 80px;
}
.main-container{
  position: relative;
  height: calc(100% - 70px);
  overflow-y: auto;
  background-color: #E7E8EB;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container-inner{
  width: 989px;
  height: 483px;
  background-color: #fff;
  display: flex;
}
.img-container{
  width: 488px;
  padding: 117px 0 0 84px;
}
.right-container{
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tip{
    color: #7A7A7C;
    font-size: 14px;
    margin-bottom: 52px;
    height: 30px;
  }
  .el-button{
    font-size: 16px;
    padding: 15px 42px;
  }
  .company-name{
    color: #7A7F83;
    font-size: 14px;
    font-weight: 500;
    margin: 8px 0 40px;
    height: 20px;
    text-align: center;
  }
}
.el-icon-arrow-left,.el-icon-arrow-right{
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}
</style>
